import ConfirmDeleteDialog from '../../../../components/ConfirmDeleteDialog/ConfirmDeleteDialog';
import type { TopicDatabase } from '../../../../types';
import { useDeleteTopicModal } from './useDeleteTopicModal';

// Keeps the French quotes and question mark on the topic name's line.
const NBSP = ' ';

type Props = {
  topic: TopicDatabase;
  onClose: () => void;
  onDeleted?: (topicId: string) => void;
};

export default function DeleteTopicModal(props: Props) {
  const hook = useDeleteTopicModal(props);

  return (
    <ConfirmDeleteDialog
      title="Supprimer le sujet"
      onConfirm={hook.handleConfirm}
      onClose={props.onClose}
    >
      Supprimer le sujet «{NBSP}{props.topic.name}{NBSP}» et tous ses sous-sujets{NBSP}?
    </ConfirmDeleteDialog>
  );
}
